// extracted by mini-css-extract-plugin
export default {"pricing":"styles_pricing__oqmbu"};